export default __webpack_public_path__ + "media/src/assets/images/triangle-897a72fc54b835d7f975169b72f9612a.svg";